import { Injectable } from '@angular/core';
import { quoteLevelConstants } from '../../constants/attribute-values.constants';

@Injectable({
  providedIn: 'root'
})
export class DealPartnerFunctionalityService {

  constructor() { }

  public static isDealPartner(source: string) {
    let isValid = false;
    if (source === 'J' || source === 'K' || source === 'H' || source === 'F' || source === 'L'
      || source === 'M' || source === 'N' || source === 'O' || source === 'P') {
      isValid = true;
    } else {
      isValid = false;
    }
    return isValid;
  }
  public static isDealPartnerWithoutProductCode(source: string) {
    let isValid = false;
    if (source === 'L' || source === 'M' || source === 'P') {
      isValid = true;
    } else {
      isValid = false;
    }
    return isValid;
  }

  public static isDealPartnerWithoutExternalFund(source: string) {
    let isValid = false;
    if (source === 'L' || source === 'M' || source === 'N' || source === 'P') {
      isValid = true;
    } else {
      isValid = false;
    }
    return isValid;
  }

  public static isGARProduct(garIndicator: string) {
    if (garIndicator === quoteLevelConstants.garIndicators.yes || garIndicator === quoteLevelConstants.garIndicators.ignored
      || garIndicator === quoteLevelConstants.garIndicators.beaten || garIndicator === quoteLevelConstants.garIndicators.featured) {
      return true;
    }
    return false;
  }
  public static gmpMaritalCheck(maritalStatus: string) {
    if (maritalStatus === quoteLevelConstants.maritalStatus.married
      || maritalStatus === quoteLevelConstants.maritalStatus.registeredCP
      || maritalStatus === quoteLevelConstants.maritalStatus.seperated) {
      return true;
    }
    return false;
  }
  public static spouseBenefit(quoteFundInfo, pensionSaving) {
    if ((!quoteFundInfo['dependentPensionPercentage'] || (quoteFundInfo['dependentPensionPercentage'] && quoteFundInfo['dependentPensionPercentage'] === 0))
      && pensionSaving['relationshipToCustomer'] === 'S') {
      return true;
    } else {
      return false;
    }
  }
  /* checks if the source is either External or HSBC */
  public static checkForNonDP(source: string) {
    return (source && (source === 'B' || source === 'R')) ? true : false;
  }
}
